import { createAction } from 'redux-actions';
import { GdsServicesRefundInfoState } from '../types';

export const SET_GDS_SERVICES_REFUND_INFO = 'REFUND/SET_GDS_SERVICES_REFUND_INFO ';

export const setGdsServicesRefundInfo = createAction<GdsServicesRefundInfoState>(SET_GDS_SERVICES_REFUND_INFO);

export type SetGdsServicesRefundInfoAction = ReturnType<typeof setGdsServicesRefundInfo>;

export type ActionGdsServicesRefundInfoTypes = SetGdsServicesRefundInfoAction;
